var map = {
	"./address-white.svg": "795b",
	"./agreement.svg": "148c",
	"./answer.svg": "d426",
	"./arrow-left.svg": "1e8e",
	"./arrow.svg": "fae1",
	"./arrow2.svg": "063f",
	"./bj-order-bj.svg": "9daf",
	"./bj-order-by.svg": "42db",
	"./bj-order-gold.svg": "30f2",
	"./bj-order-hj.svg": "4d82",
	"./bj-order-hz.svg": "ffb3",
	"./bj-order-zs.svg": "d28c",
	"./bj-service-bj.svg": "3c7a",
	"./bj-service-by.svg": "1dd4",
	"./bj-service-hj.svg": "305c",
	"./bj-service-hz.svg": "a0c9",
	"./bj-service-zs.svg": "70e0",
	"./cancel-order.svg": "ff3d",
	"./cancel.svg": "5341",
	"./category-arrow.svg": "95f8",
	"./centification.svg": "9097",
	"./checkdate.svg": "63fe",
	"./checkmark.svg": "b959",
	"./chevron-down.svg": "ee3e",
	"./chevron-up.svg": "103c",
	"./close-btn.svg": "f7ba",
	"./close-white.svg": "6b42",
	"./close.svg": "f62a",
	"./copy.svg": "f19f",
	"./cp-draw-modal-cancel.svg": "5b3d",
	"./customer_icon.svg": "15a0",
	"./down.svg": "8040",
	"./facilitie-房间配套.svg": "8f06",
	"./facilitie-通用服务.svg": "ce81",
	"./facilitie-酒店设施.svg": "0843",
	"./fail.svg": "81f4",
	"./green-order.svg": "9887",
	"./green-service.svg": "93b1",
	"./haixin-order.svg": "9901",
	"./haixin-service.svg": "7c08",
	"./help-service.svg": "9e5e",
	"./hotel-success.svg": "454b",
	"./hotel_cancel.svg": "e744",
	"./hotel_date.svg": "f3d6",
	"./hotel_success.svg": "c9ee",
	"./hotel_unpay.svg": "9bb3",
	"./hotelcheckmark.svg": "0893",
	"./hotelpricetop.svg": "99ff",
	"./hudun-order.svg": "5c0d",
	"./hudun-service.svg": "70b6",
	"./info.svg": "0372",
	"./keep-logout-icon.svg": "0961",
	"./keep-order.svg": "1c2a",
	"./keep-service.svg": "f9db",
	"./konka-order.svg": "4d1a",
	"./konka-service.svg": "351f",
	"./leiniao-order.svg": "3c99",
	"./leiniao-service.svg": "1094",
	"./map-route-icon.svg": "7beb",
	"./map-service.svg": "67a7",
	"./matter-notice.svg": "2319",
	"./naba.svg": "9ccf",
	"./order-cancel.svg": "98de",
	"./order-success.svg": "f87a",
	"./order-wait.svg": "d646",
	"./order.svg": "d057",
	"./order_icon.svg": "1d69",
	"./park.svg": "ea98",
	"./pay-result-fail-black.svg": "f8b9",
	"./pay-result-fail-gold.svg": "f144",
	"./pay-result-success-black.svg": "5f01",
	"./pay-result-success-gold.svg": "7f44",
	"./pay-result-unpaid-black.svg": "d84a",
	"./pay-result-unpaid-gold.svg": "dbb0",
	"./phone-white.svg": "18af",
	"./redeem.svg": "b495",
	"./select.svg": "2791",
	"./service.svg": "79cd",
	"./success-green.svg": "0395",
	"./success.svg": "709e",
	"./tag-不可累计房晚和积分.svg": "5bdb",
	"./tag-专属价.svg": "e5c9",
	"./tag-会员专属价.svg": "6585",
	"./tag-免费取消.svg": "e7df",
	"./tag-入住前一天免费取消.svg": "a14d",
	"./tag-固定价.svg": "d49f",
	"./tag-累计积分.svg": "4a4d",
	"./tag2-不可累计房晚和积分.svg": "cd6e",
	"./tag2-专属价.svg": "9e7a",
	"./tag2-会员专属价.svg": "b341",
	"./tag2-免费取消.svg": "ca4a",
	"./tag2-入住前一天免费取消.svg": "39ad",
	"./tag2-固定价.svg": "3ca7",
	"./tag2-累计积分.svg": "0cbd",
	"./unpay.svg": "600b",
	"./white-arrow.svg": "44ce",
	"./免费取消.svg": "c5321"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79ff";